export default __webpack_public_path__ + "img/mel_laneway-41f951724e19d6160503d29738bb751e.png";